import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlJob } from "~/__generated__";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import WorkerJobStatus from "~/modules/app/components/WorkerJobStatus";
import FileUploaderStatus from "~/modules/media/components/FileUploaderStatus";

import useUserImportStart from "../api/useUserImportStart";
import UserImportFeedback from "../components/UserImportFeedback";

const feedback = (data: GqlJob) => <UserImportFeedback job={data} />;

export default function UserImportScreen() {
    const { t } = useTranslation("user");
    const { startUserImportJob, loading, data } = useUserImportStart();

    async function startImportJob(mediaId: string) {
        startUserImportJob(mediaId);
    }

    return (
        <GaiaPageLayoutColumn>
            <Typography variant="h4">{t("userImportScreen.title")}</Typography>
            {!data && !loading && (
                <FileUploaderStatus
                    multiple={false}
                    fileTypesToAccept={{ "text/csv": [".csv"] }}
                    onUploadFinished={([e]) => startImportJob(e.id)}
                />
            )}
            {data && <WorkerJobStatus worker="UserImportWorker" jobId={data.id} renderFeedback={feedback} />}
        </GaiaPageLayoutColumn>
    );
}
